var stockCategory_RowIndex_Array = [];
var groupSummary_level_0_RowsIndex_Array = [];
var reportType = null;


function prepareExcel(dataObj){

    let headerRow1 = [dataObj.otherData.headerRow1];
    let headerRow2 = [dataObj.otherData.headerRow2];
    let headerRow3 = [dataObj.otherData.headerRow3];
    let headerRow4 = dataObj.otherData.headerRow4 ? [dataObj.otherData.headerRow4] : null;
    //this row is for advance filters;
    let headerRow5 = dataObj.otherData.headerRow5 ? [dataObj.otherData.headerRow5] : null;

    let tableHeader = [];
    let headerCols = dataObj.reportDataObject.reportData.headerRow;

    let headerInternalCols = null;
    if(dataObj.reportDataObject.reportData.internalHeaderRow){
      headerInternalCols = dataObj.reportDataObject.reportData.internalHeaderRow;  
    }
    

    for(let key in headerCols){
      tableHeader.push(headerCols[key]);

      //setting up header columns except first to null
      // if(key!='col1'){
        headerRow1.push(null);
        headerRow2.push(null);
        headerRow3.push(null);
        headerRow4 ? headerRow4.push(null) : '';
        headerRow5 ? headerRow5.push(null) : '';
      // }
    }

    // pushing null item to first header in case of header object keys length is shorter than internal header object keys length;
    if(headerInternalCols){
      let internalHeaderLength = 0;
      for(let key in headerInternalCols){
        internalHeaderLength++;
      }

      if(headerRow1.length < internalHeaderLength){
        let lengthDiff = internalHeaderLength - headerRow1.length;
        for(let i=0; i<lengthDiff; i++){
          headerRow1.push(null);
        }
      }
    }
    

    var excelData = [];
    excelData.push(headerRow1);
    excelData.push(headerRow2);
    excelData.push(headerRow3);

    let headerRowCount = 4;//headerRow1 + headerRow2 + headerRow3 + tableHeader

    if(headerRow4){
      excelData.push(headerRow4); 
      headerRowCount += 1;
    }

    if(headerRow5){
      excelData.push(headerRow5); 
      headerRowCount += 1;
    }
    // headerRow4 ? excelData.push(headerRow4) : '';
    // headerRow5 ? excelData.push(headerRow5) : '';
    excelData.push(tableHeader);

    for(var i=0; i<dataObj.reportDataObject.reportData.detailRows.length; i++){

      let tableRow = [];
      let item = dataObj.reportDataObject.reportData.detailRows[i];
      for(let key in headerCols){
        console.log(headerCols[key]+': '+item.cols[key]);
        if(headerCols[key]=='Date' || key=='transactionDate' || key=='shippingBillDate' || key=='referenceTransactionDate' || key=='refDate' || key=='expiryDate' || key=='expDate' || key=='mfgDate'){
          item.cols[key] = item.cols[key] ? formatDate(item.cols[key]) : '';
        }
        else if(key=='expiredIn'){
          item.cols[key] < 0 ? item.cols[key] = '' : '';
        }
        tableRow.push(item.cols[key]);
      }

      excelData.push(tableRow);

      if(item.cols.otherTax && item.cols.otherTax.items && item.cols.otherTax.items.length){
              
        tableRow = [];
        for(var col in headerInternalCols){
          tableRow.push(headerInternalCols[col]);
        }
        excelData.push(tableRow);

        for(var j=0; j<item.cols.otherTax.items.length; j++){
          let otherItem = item.cols.otherTax.items[j];

          tableRow = [];
          for(let hCol in headerInternalCols){
            tableRow.push(otherItem[hCol]);
          }
          excelData.push(tableRow);
        }

        if(item.cols.otherTax.total){
          tableRow = [];
          for(let tCol in headerInternalCols){
              tableRow.push(item.cols.otherTax.total[tCol]);
          }
          excelData.push(tableRow); 
        }

      }

      if(item.cols.itemDetailRows && item.cols.itemDetailRows.length){
              
        tableRow = [];
        // for(var col in item.subHeaders){
        //   tableRow.push(item.subHeaders[col]);
        // }
        tableRow.push(item.subHeaders.srNo);
        tableRow.push(item.subHeaders.productName);
        item.subHeaders.hsnCode ? tableRow.push(item.subHeaders.hsnCode) : '';
        tableRow.push(item.subHeaders.qty);
        tableRow.push(item.subHeaders.unit);
        tableRow.push(item.subHeaders.rate);
        item.subHeaders.discount ? tableRow.push(item.subHeaders.discount) : '';
        tableRow.push(item.subHeaders.taxableValue);
        item.subHeaders.gstPercentage ? tableRow.push(item.subHeaders.gstPercentage) : '';
        item.subHeaders.cgst ? tableRow.push(item.subHeaders.cgst) : '';
        item.subHeaders.sgst ? tableRow.push(item.subHeaders.sgst) : '';
        item.subHeaders.utgst ? tableRow.push(item.subHeaders.utgst) : '';
        item.subHeaders.igst ? tableRow.push(item.subHeaders.igst) : '';
        item.subHeaders.cessPercentage ? tableRow.push(item.subHeaders.cessPercentage) : '';
        item.subHeaders.cessOnQtyPercentage ? tableRow.push(item.subHeaders.cessOnQtyPercentage) : '';
        item.subHeaders.cess ? tableRow.push(item.subHeaders.cess) : '';
        tableRow.push(item.subHeaders.total);

        excelData.push(tableRow);

        for(var j=0; j<item.cols.itemDetailRows.length; j++){
          let otherItem = item.cols.itemDetailRows[j];

          tableRow = [];
          if(item.subHeaders){
            // for(let hCol in item.subHeaders){
            //   tableRow.push(otherItem[hCol]);
            // }
            tableRow.push(otherItem.srNo);
            tableRow.push(otherItem.productName);
            item.subHeaders.hsnCode ? tableRow.push(otherItem.hsnCode) : '';
            tableRow.push(otherItem.qty);
            tableRow.push(otherItem.unit);
            tableRow.push(otherItem.rate);
            item.subHeaders.discount ? tableRow.push(otherItem.discount) : '';
            tableRow.push(otherItem.taxableValue);
            // otherItem.cgst ? tableRow.push(otherItem.cgst) : '';
            // otherItem.sgst ? tableRow.push(otherItem.sgst) : '';
            // otherItem.igst ? tableRow.push(otherItem.igst) : '';
            if(item.subHeaders.gstPercentage){
              tableRow.push(otherItem.gstPercentage);
            }

            if(item.subHeaders.cgst){
              tableRow.push(otherItem.cgst);
              if(item.subHeaders.utgst){
                tableRow.push(otherItem.utgst); 
              }
              else{
                tableRow.push(otherItem.sgst);  
              }
            }
            
            if(item.subHeaders.igst){
              tableRow.push(otherItem.igst);
            }

            if(item.subHeaders.cessPercentage){
              tableRow.push(otherItem.cessPercentage);
            }

            if(item.subHeaders.cessOnQtyPercentage){
              tableRow.push(otherItem.cessOnQtyPercentage);
            }

            if(item.subHeaders.cess){
              tableRow.push(otherItem.cess);
            }
            tableRow.push(otherItem.total);
            excelData.push(tableRow);
          }
          
        }

        if(item.cols.subTotal){
          tableRow = [];
          tableRow.push(item.cols.subTotal.srNo);
          tableRow.push(item.cols.subTotal.productName);
          item.subHeaders.hsnCode ? tableRow.push(item.cols.subTotal.hsnCode) : '';
          tableRow.push(item.cols.subTotal.qty);
          tableRow.push(item.cols.subTotal.unit);
          tableRow.push(item.cols.subTotal.rate);
          item.subHeaders.discount ? tableRow.push(item.cols.subTotal.discount) : '';
          tableRow.push(item.cols.subTotal.taxableValue);
          // item.cols.subTotal.cgst ? tableRow.push(item.cols.subTotal.cgst) : '';
          // item.cols.subTotal.sgst ? tableRow.push(item.cols.subTotal.sgst) : '';
          // item.cols.subTotal.igst ? tableRow.push(item.cols.subTotal.igst) : '';
          if(item.subHeaders.gstPercentage){
            tableRow.push(item.cols.subTotal.gstPercentage);
          }

          if(item.subHeaders.cgst){
            tableRow.push(item.cols.subTotal.cgst);
            if(item.subHeaders.utgst){
              tableRow.push(item.cols.subTotal.utgst);
            }
            else{
              tableRow.push(item.cols.subTotal.sgst);  
            }
          }
          
          if(item.subHeaders.igst){
            tableRow.push(item.cols.subTotal.igst);
          }

          if(item.subHeaders.cessPercentage){
            tableRow.push(item.cols.subTotal.cessPercentage);
          }

          if(item.subHeaders.cessOnQtyPercentage){
            tableRow.push(item.cols.subTotal.cessOnQtyPercentage);
          }

          if(item.subHeaders.cess){
            tableRow.push(item.cols.subTotal.cess);
          }
          tableRow.push(item.cols.subTotal.total);
          excelData.push(tableRow);
        }

        if(item.cols.billAddOns){
          tableRow = [];
          tableRow.push(item.cols.billAddOns.srNo);
          tableRow.push(item.cols.billAddOns.productName);
          item.subHeaders.hsnCode ? tableRow.push(item.cols.billAddOns.hsnCode) : '';
          tableRow.push(item.cols.billAddOns.qty);
          tableRow.push(item.cols.billAddOns.unit);
          tableRow.push(item.cols.billAddOns.rate);
          item.subHeaders.discount ? tableRow.push(item.cols.billAddOns.discount) : '';
          tableRow.push(item.cols.billAddOns.taxableValue);
          item.subHeaders.gstPercentage ? tableRow.push(item.cols.billAddOns.gstPercentage) : '';
          item.subHeaders.cgst ? tableRow.push(item.cols.billAddOns.cgst) : '';
          item.subHeaders.sgst ? tableRow.push(item.cols.billAddOns.sgst) : '';
          item.subHeaders.igst ? tableRow.push(item.cols.billAddOns.igst) : '';
          item.subHeaders.cessPercentage ? tableRow.push(item.cols.billAddOns.cessPercentage) : '';
          item.subHeaders.cessOnQtyPercentage ? tableRow.push(item.cols.billAddOns.cessOnQtyPercentage) : '';
          item.subHeaders.cess ? tableRow.push(item.cols.billAddOns.cess) : '';
          tableRow.push(item.cols.billAddOns.total);
          excelData.push(tableRow);
        }

        if(item.cols.tdsAddOns){
          tableRow = [];
          tableRow.push('Total Tds');
          tableRow.push('');
          item.subHeaders.hsnCode ? tableRow.push('') : '';
          tableRow.push('');
          tableRow.push('');
          tableRow.push('');
          item.subHeaders.discount ? tableRow.push('') : '';
          tableRow.push('');
          item.subHeaders.gstPercentage ? tableRow.push('') : '';
          item.subHeaders.cgst ? tableRow.push('') : '';
          item.subHeaders.sgst ? tableRow.push('') : '';
          item.subHeaders.igst ? tableRow.push('') : '';
          item.subHeaders.cessPercentage ? tableRow.push('') : '';
          item.subHeaders.cessOnQtyPercentage ? tableRow.push('') : '';
          item.subHeaders.cess ? tableRow.push('') : '';
          tableRow.push(item.cols.tdsAddOns.total);
          excelData.push(tableRow);
        }

        if(item.cols.total){
          tableRow = [];
          tableRow.push(item.cols.total.srNo);
          tableRow.push(item.cols.total.productName);
          item.subHeaders.hsnCode ? tableRow.push(item.cols.total.hsnCode) : '';
          tableRow.push(item.cols.total.qty);
          tableRow.push(item.cols.total.unit);
          tableRow.push(item.cols.total.rate);
          item.subHeaders.discount ? tableRow.push(item.cols.total.discount) : '';
          tableRow.push(item.cols.total.taxableValue);

          if(item.subHeaders.gstPercentage){
            tableRow.push(item.cols.total.gstPercentage);
          }

          // item.cols.total.cgst ? tableRow.push(item.cols.total.cgst) : '';
          // item.cols.total.sgst ? tableRow.push(item.cols.total.sgst) : '';
          // item.cols.total.igst ? tableRow.push(item.cols.total.igst) : '';
          if(item.subHeaders.cgst){
            tableRow.push(item.cols.total.cgst);
            if(item.subHeaders.utgst){
              tableRow.push(item.cols.total.utgst);  
            }
            else{
              tableRow.push(item.cols.total.sgst);  
            }
          }

          if(item.subHeaders.igst){
            tableRow.push(item.cols.total.igst);
          }
          
          if(item.subHeaders.cessPercentage){
            tableRow.push(item.cols.total.cessPercentage);
          }

          if(item.subHeaders.cessOnQtyPercentage){
            tableRow.push(item.cols.total.cessOnQtyPercentage);
          }

          if(item.subHeaders.cess){
            tableRow.push(item.cols.total.cess);
          }
          tableRow.push(item.cols.total.total);
          excelData.push(tableRow);
        }

        // pushing empty cols as fixing uneven length of columns
          for(let m=0; m<excelData.length; m++){
            let emptyColLength = 16 - excelData[m].length;
            for(let n=0; n<emptyColLength; n++){
              excelData[m].push(null);
            }
          }

        // if(item.footerRow){
        //   tableRow = [];
        //   for(let tCol in headerInternalCols){
        //       tableRow.push(item.footerRow[tCol]);
        //   }
        //   excelData.push(tableRow); 
        // }

      }
    }

    let isFooterRow = false;
    let isSummaryRow = false;

    if(dataObj.reportDataObject.reportData.footerRow){
      let tableFooter = [];
      let footerCols = dataObj.reportDataObject.reportData.footerRow;

      if(headerInternalCols){
        for(let key in headerInternalCols){
          tableFooter.push(footerCols[key]);
        }  
      }
      else{
        for(let key in headerCols){
          tableFooter.push(footerCols[key]);
        }  
      }

      excelData.push(tableFooter);
      isFooterRow = true;
    }

    //only for outstanding recivable and payable reports
    if(dataObj.reportDataObject.reportData.summaryRows){
      let footerRows = dataObj.reportDataObject.reportData.summaryRows;
        let footerColumns = ['', '', 'mergeTransactionNumber', 'transactionListId'];
        for(let i=0; i<footerRows.length; i++){
          let tableFooter = [];
          let rows = footerRows[i];
          for(let i in footerColumns){
            tableFooter.push(rows[footerColumns[i]]);
          }
          excelData.push(tableFooter);
      }
      isFooterRow = true;
      isSummaryRow = true;
    }

    // let isFilterRow = headerRow5 ? true : false;

    exportExcel(excelData, isFooterRow, headerRowCount, isSummaryRow);
}

function formatDate(dateStr){
  let dateObj = new Date(dateStr);
  console.log(dateObj);
  return ("0" + dateObj.getDate()).slice(-2) + "/" + ("0" + (dateObj.getMonth()+1)).slice(-2) + "/" +  dateObj.getFullYear();
    // return date_obj.getFullYear() + "/" + ("0" + (date_obj.getMonth()+1)).slice(-2) + "/" + ("0" + date_obj.getDate()).slice(-2);
}

function exportExcel(data, isFooterRow, headerRowCount, isSummaryRow){

      console.log('called 2');

      const XlsxPopulate = require('xlsx-populate');

      // let headerRowCount = isFilterRow ? 6 : 5;

      XlsxPopulate.fromBlankAsync()
          .then(workbook => {
              // Modify the workbook.
              // workbook.sheet("Sheet1").cell("A1").value("This is neat");

              console.log('called 3');

              workbook.sheet(0).cell("A1").value(data);

              //removing slashes while setting up sheet name
              let sheetName = data[1][0].replace(/\//g, '');
              workbook.sheet(0).name(sheetName);

                  var tbl_LastColumn_Index = data[0].length - 1;
                  var tbl_LastRow_Index = data.length;

                  //Getting first row and first col address
                  const tbl_FirstRow_FirstCell = workbook.sheet(0).cell(headerRowCount,1).address();
                  //Getting first row last col address
                  const tbl_FirstRow_LastCell = workbook.sheet(0).cell(headerRowCount,tbl_LastColumn_Index).address();
                  //Getting last row first col address
                  const tbl_LastRow_FirstCell = workbook.sheet(0).cell(tbl_LastRow_Index,1).address();
                  //Getting last row last col address
                  const tbl_LastRow_LastCell = workbook.sheet(0).cell(tbl_LastRow_Index, tbl_LastColumn_Index).address();


                  //Getting column name e.g A,B,C....
                  // const cell = workbook.sheet(0).column(lastColumnIndex).columnName();
                  //Setting column width
                  // workbook.sheet(0).column(cell).width(100).hidden(false);

                  var headerRange = tbl_FirstRow_FirstCell+":"+tbl_FirstRow_LastCell;
                  var footerRange = tbl_LastRow_FirstCell+":"+tbl_LastRow_LastCell;
                  
                  //Setting cell styles
                  workbook.sheet(0).range(headerRange).style({"fill": "dddddd", "bold": true});

                  isFooterRow ? workbook.sheet(0).range(footerRange).style({"bold": true}) : '';

                  if(isSummaryRow){
                    const tbl_SecondLastRow_FirstCell = workbook.sheet(0).cell(tbl_LastRow_Index-1,1).address();
                    const tbl_SecondLastRow_LastCell = workbook.sheet(0).cell(tbl_LastRow_Index-1, tbl_LastColumn_Index).address();
                    const tbl_ThirdLastRow_FirstCell = workbook.sheet(0).cell(tbl_LastRow_Index-2,1).address();
                    const tbl_ThirdLastRow_LastCell = workbook.sheet(0).cell(tbl_LastRow_Index-2, tbl_LastColumn_Index).address();

                    var SecondLastFooterRange = tbl_SecondLastRow_FirstCell+":"+tbl_SecondLastRow_LastCell;
                    var ThirdLastFooterRange = tbl_ThirdLastRow_FirstCell+":"+tbl_ThirdLastRow_LastCell;

                    workbook.sheet(0).range(SecondLastFooterRange).style({"bold": true});
                    workbook.sheet(0).range(ThirdLastFooterRange).style({"bold": true});
                  }

                  //Setting level_0 rows styles to bold (only in case of group summary report)
                  if(reportType === 'groupSummary'){
                    for(var i in groupSummary_level_0_RowsIndex_Array){
                      workbook.sheet(0).row(groupSummary_level_0_RowsIndex_Array[i]).style("bold", true);
                    }
                  }

                  groupSummary_level_0_RowsIndex_Array = [];
                  

                  //handling stock category cell formatting 
                  if(reportType=='group'){
                    for(var i=0;i<stockCategory_RowIndex_Array.length;i++){
                      var stockCategory_Row_FirstCell = workbook.sheet(0).cell(stockCategory_RowIndex_Array[i], 1).address();
                      var stockCategory_Row_LastCell = workbook.sheet(0).cell(stockCategory_RowIndex_Array[i], tbl_LastColumn_Index).address();
                      workbook.sheet(0).cell(stockCategory_Row_FirstCell).style({"fill": "dddddd", "bold": true});
                      var mergeRange = stockCategory_Row_FirstCell+':'+stockCategory_Row_LastCell
                      workbook.sheet(0).range(mergeRange).merged(true);
                    }
                  }

                  stockCategory_RowIndex_Array = [];

                  //Merge test
                  // workbook.sheet(0).range("H1:K1").merged(true);

                  
                  workbook.outputAsync("base64")
                .then(function (base64) {
                    var raw = self.atob(base64);
                    var rawLength = raw.length;
                    var array = new Uint8Array(new ArrayBuffer(rawLength));

                    for(var i = 0; i < rawLength; i++) {
                      array[i] = raw.charCodeAt(i);
                    }

                    self.postMessage(array);
                });
          });
}
 
module.exports = function worker (self) {
    self.addEventListener('message', (event) => {
        if(event.data){
            console.log('called');
            prepareExcel(event.data);
        }
    });
};


// WEBPACK FOOTER //
// ./src/components/plugins/worker_prepare_excel_data.js